import { setParams } from '@distribute/shared/utils';

import { QUERY_SHARE_ITEM_ID, QUERY_SHARE_TEAM_ID } from '../config';
import { getFullUrl } from '../../../shared/lib';

export const generateShareLinkPath = (
  path: string,
  id: string,
  teamId: string
) => {
  return `${path}${setParams({
    [QUERY_SHARE_ITEM_ID]: id,
    [QUERY_SHARE_TEAM_ID]: teamId,
  })}`;
};

export const generateShareLink = (path: string, id: string, teamId: string) => {
  return getFullUrl(generateShareLinkPath(path, id, teamId), false);
};
